"use strict";
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useMedia = void 0;
var react_1 = require("react");
var react_redux_1 = require("react-redux");
var react_reverse_portal_1 = require("react-reverse-portal");
var react_useportal_1 = __importDefault(require("react-useportal"));
var _store_1 = require("@store");
var mediasSlice_1 = require("../state/mediasSlice");
var getImageRequestUrl_1 = __importDefault(require("../utils/getImageRequestUrl"));
var isImageMetadataSuccess_1 = require("../utils/isImageMetadataSuccess");
var useMedia = function (imagesMetadata, videosMetadata, adId, shouldFetchSizedImagesOnInitialRender, shouldFetchFullImagesOnInitialRender) {
    if (shouldFetchSizedImagesOnInitialRender === void 0) { shouldFetchSizedImagesOnInitialRender = false; }
    if (shouldFetchFullImagesOnInitialRender === void 0) { shouldFetchFullImagesOnInitialRender = false; }
    var dispatch = (0, _store_1.useAppDispatch)();
    var fullImages = (0, react_redux_1.useSelector)(function (state) { return (0, mediasSlice_1.selectedMediaFullImages)(state, adId); });
    var sizedImages = (0, react_redux_1.useSelector)(function (state) { return (0, mediasSlice_1.selectedMediaSizedImages)(state, adId); });
    var selectedMedia = (0, react_redux_1.useSelector)(function (state) { return (0, mediasSlice_1.selectedMediaSelector)(state, adId); });
    var selectedMediaId = (0, react_redux_1.useSelector)(function (state) { return (0, mediasSlice_1.selectedMediaIdSelector)(state, adId); });
    var selectedFullImage = (0, react_redux_1.useSelector)(function (state) { return (0, mediasSlice_1.imageSelector)(state, adId, selectedMediaId, 'fullImage'); });
    var isVideo = selectedMedia ? selectedMedia.type === 'video' : false;
    var getImage = function (imageMetadata, imageType) {
        if ((0, isImageMetadataSuccess_1.isImageMetadataSuccess)(imageMetadata)) {
            var originalSize = imageMetadata.originalSize, imageServiceUrl = imageMetadata.imageServiceUrl, id = imageMetadata.id;
            var imageRequestUrl = (0, getImageRequestUrl_1.default)(imageType, imageServiceUrl, originalSize);
            dispatch((0, mediasSlice_1.fetchImage)(adId, id, imageRequestUrl, imageType));
        }
        else {
            var id = imageMetadata.id;
            dispatch((0, mediasSlice_1.setBrokenImage)({ adId: adId, imageId: id, imageType: imageType }));
        }
    };
    var getImagesForModal = function () {
        var e_1, _a;
        var fullImageIds = fullImages.map(function (image) { return image.id; });
        var sizedImageIds = sizedImages.map(function (image) { return image.id; });
        try {
            for (var imagesMetadata_1 = __values(imagesMetadata), imagesMetadata_1_1 = imagesMetadata_1.next(); !imagesMetadata_1_1.done; imagesMetadata_1_1 = imagesMetadata_1.next()) {
                var imageMetadata = imagesMetadata_1_1.value;
                var imageMetadataId = imageMetadata.id;
                if (!fullImageIds.includes(imageMetadataId)) {
                    getImage(imageMetadata, 'fullImage');
                }
                if (!sizedImageIds.includes(imageMetadataId)) {
                    getImage(imageMetadata, 'sizedImage');
                }
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (imagesMetadata_1_1 && !imagesMetadata_1_1.done && (_a = imagesMetadata_1.return)) _a.call(imagesMetadata_1);
            }
            finally { if (e_1) throw e_1.error; }
        }
    };
    // we set the metadata and the first selected media id
    (0, react_1.useEffect)(function () {
        dispatch((0, mediasSlice_1.setMetadata)({ adId: adId, videosMetadata: videosMetadata, imagesMetadata: imagesMetadata }));
    }, [adId, imagesMetadata, videosMetadata]);
    (0, react_1.useEffect)(function () {
        return function () {
            dispatch((0, mediasSlice_1.clearImages)({ adId: adId }));
        };
    }, []);
    (0, react_1.useEffect)(function () {
        var getSizedImages = function () {
            var e_2, _a;
            var _b;
            try {
                for (var imagesMetadata_2 = __values(imagesMetadata), imagesMetadata_2_1 = imagesMetadata_2.next(); !imagesMetadata_2_1.done; imagesMetadata_2_1 = imagesMetadata_2.next()) {
                    var imageMetadata = imagesMetadata_2_1.value;
                    // if image has cropping then we fetch main image instead of sized
                    // to display bounding boxes correctly. We might need to change it later
                    if ((0, isImageMetadataSuccess_1.isImageMetadataSuccess)(imageMetadata) && ((_b = imageMetadata.transformations) === null || _b === void 0 ? void 0 : _b.cropping)) {
                        getImage(imageMetadata, 'fullImage');
                    }
                    else {
                        getImage(imageMetadata, 'sizedImage');
                    }
                }
            }
            catch (e_2_1) { e_2 = { error: e_2_1 }; }
            finally {
                try {
                    if (imagesMetadata_2_1 && !imagesMetadata_2_1.done && (_a = imagesMetadata_2.return)) _a.call(imagesMetadata_2);
                }
                finally { if (e_2) throw e_2.error; }
            }
        };
        var getFullImages = function () {
            var e_3, _a;
            try {
                for (var imagesMetadata_3 = __values(imagesMetadata), imagesMetadata_3_1 = imagesMetadata_3.next(); !imagesMetadata_3_1.done; imagesMetadata_3_1 = imagesMetadata_3.next()) {
                    var imageMetadata = imagesMetadata_3_1.value;
                    getImage(imageMetadata, 'fullImage');
                }
            }
            catch (e_3_1) { e_3 = { error: e_3_1 }; }
            finally {
                try {
                    if (imagesMetadata_3_1 && !imagesMetadata_3_1.done && (_a = imagesMetadata_3.return)) _a.call(imagesMetadata_3);
                }
                finally { if (e_3) throw e_3.error; }
            }
        };
        shouldFetchSizedImagesOnInitialRender && getSizedImages();
        shouldFetchFullImagesOnInitialRender && getFullImages();
    }, [adId, shouldFetchFullImagesOnInitialRender, shouldFetchSizedImagesOnInitialRender]);
    (0, react_1.useEffect)(function () {
        if (shouldFetchFullImagesOnInitialRender) {
            return;
        }
        var selectedMediaMetadata = imagesMetadata.find(function (metadata) { return metadata.id === selectedMediaId; });
        if (!selectedFullImage && selectedMediaMetadata && !isVideo) {
            getImage(selectedMediaMetadata, 'fullImage');
        }
    }, [selectedMediaId]);
    var _a = (0, react_useportal_1.default)({
        onOpen: function (_a) {
            var portal = _a.portal;
            // eslint-disable-next-line no-param-reassign
            portal.current.style.cssText = "\n              /* add your css here for the Portal */\n              width: 100vw;\n              height: 100vh;\n              position:fixed;\n              left: 50%;\n              top: 50%;\n              transform: translate(-50%,-50%);\n              right: auto;\n              bottom: auto;\n              margin-right: -50%;\n              padding: 0;\n              border: none;\n              border-radius: 0;\n              background-color: black;\n            ";
            // eslint-disable-next-line no-param-reassign
            portal.current.className = 'modal media-gallery-modal';
            var body = document.querySelector('body');
            body && body.style.setProperty('overflow-y', 'hidden', 'important');
            getImagesForModal();
        },
        onClose: function (_a) {
            var portal = _a.portal;
            portal.current.removeAttribute('style');
            // eslint-disable-next-line no-param-reassign
            portal.current.className = '';
            var body = document.querySelector('body');
            body && body.style.setProperty('overflow-y', 'visible', 'important');
            // we reset the selected media id to the first image id when closing the modal
            !shouldFetchSizedImagesOnInitialRender &&
                isVideo === false &&
                dispatch((0, mediasSlice_1.setSelectedMediaId)({ adId: adId, selectedMediaId: fullImages[0].id }));
        },
    }), openMediaGalleryModal = _a.openPortal, closeMediaGalleryModal = _a.closePortal, isModalOpen = _a.isOpen, Portal = _a.Portal;
    // isvideo???
    var portalNode = (0, react_1.useMemo)(function () { return (0, react_reverse_portal_1.createHtmlPortalNode)({ attributes: { class: isVideo ? 'main-video-container' : 'media-gallery-modal-container' } }); }, []);
    return { openMediaGalleryModal: openMediaGalleryModal, closeMediaGalleryModal: closeMediaGalleryModal, isModalOpen: isModalOpen, portalNode: portalNode, Portal: Portal };
};
exports.useMedia = useMedia;
